module.exports = " <div class=vc-refresh-control :style=refreshStyle :class=\"{'vc-refresh-control-refreshing': refreshing}\"> <icon v-show=\"!refreshing && draging\" value=refresh :style=circularStyle></icon> <circular v-show=refreshing :size=20 :border-width=2></circular> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/refreshControl.vue
 ** module id = 476
 ** module chunks = 1
 **/